export class Owner {
    private value: string

    constructor (value: string) {
      this.value = value
    }

    owner (): string {
      return this.value
    }
}
